const MyBlogs = () => {
    return (
        <div>My Blogs</div>
    )
}

export default MyBlogs;